module.exports = __webpack_public_path__ + "static/logo-with-text-2baed06fcd959ea88c08b11db4fdd7a3.svg";